export const aws =
	// process.env.NEXT_PUBLIC_AWS_URL ||
	"https://soe-storage.s3.ap-southeast-1.amazonaws.com/images/";

export const getImageUrl = (path: string): string => {
	if (!path) return "/fallback-image.png";
	return `${aws}${path}`;
};
